import Dots from 'components/Dots';
import Footer from 'components/Footer';
import ImagePopup from 'components/ImagePopup';
import MainImage from 'components/MainImage';
import OneDayPopup from 'components/OneDayPopup';
import PartnerNew from 'components/PartnerNew';
import ProductMenu from 'components/ProductMenu';
import ProductMenuNew from 'components/ProductMenuNew';
import Slideritem from 'components/SliderItmes';
import URL from 'constants/url';
// import MainImage from 'components/MainImage';
// import Partner from 'components/Partner'
// import ProductMenu from 'components/ProductMenu';
// import URL from 'constants/url'
// import React, { useEffect, useRef, useState } from 'react'
// import { Link } from 'react-router-dom'

// function Main2() {
//   const DIVIDER_HEIGHT = 5;
//   const outerDivRef = useRef();
//   const FOOTER_HEIGHT = 348;
//   const [currentPage, setCurrentPage] = useState(1);
//   let startY;
//   let endY;

//   useEffect(() => {
//     const wheelHandler = (e) => {
//       e.preventDefault();
//       // const { deltaY } = e;
//       // const values = Object.values(obj);
//       const values = "changedTouches" in e  ? endY : 0 ;
//       const deltaY = 'deltaY' in e ? e.deltaY : startY - e.touches[0].clientY;  
//       // const deltaY = 'deltaY' in e ? e.deltaY : startY - (e.touches[0].clientY /2);
//       const { scrollTop } = outerDivRef.current; // 스크롤 위쪽 끝부분 위치
//       const pageHeight = window.innerHeight; // 화면 세로길이, 100vh와 같습니다.
//       // console.log(e)
//       console.log(deltaY)
//       // console.log("!!!",e.touches[0].clientY)
//       if (deltaY > 0) {
//         // 스크롤 내릴 때
//         if (scrollTop >= 0 && scrollTop < pageHeight) {
//           //현재 1페이지
//           console.log("현재 1페이지, down scrollTop:",scrollTop, "pageHeight:",pageHeight);
//           outerDivRef.current.scrollTo({
//             top: pageHeight + DIVIDER_HEIGHT,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(2);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 2) {
//           //현재 2페이지
//           console.log("현재 2페이지, down scrollTop:",scrollTop, "pageHeight:",pageHeight* 2);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 2 + DIVIDER_HEIGHT ,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(3);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 3) {
//           // 현재 3페이지
//           console.log("현재 3페이지, down scrollTop:",scrollTop, "pageHeight:",pageHeight* 3);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 3 + DIVIDER_HEIGHT ,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(4);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 4) {
//           // 현재 4페이지
//           console.log("현재 4페이지, down scrollTop:",scrollTop, "pageHeight:",pageHeight* 4);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 4 + DIVIDER_HEIGHT,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(5);
//         } else {
//           // 현재 5페이지
//           console.log("현재 5페이지, down scrollTop:",scrollTop, "pageHeight:",pageHeight*5);
//           outerDivRef.current.scrollTo({
//             top: (pageHeight * 5 + DIVIDER_HEIGHT * 5) ,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(6);
//         }
//       } else {
//         // 스크롤 올릴 때
//         if (scrollTop >= 0 && scrollTop < pageHeight) {
//           //현재 1페이지
//           console.log("현재 1페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight);
//           outerDivRef.current.scrollTo({
//             top: 0,
//             left: 0,
//             behavior: "smooth",
//           });
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 2) {
//           //현재 2페이지
//           console.log("현재 2페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight);
//           outerDivRef.current.scrollTo({
//             top: 0,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(1);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 3) {
//           // 현재 3페이지
//           console.log("현재 3페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight);
//           outerDivRef.current.scrollTo({
//             top: pageHeight + DIVIDER_HEIGHT,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(2);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 4) {
//           // 현재 4페이지
//           console.log("현재 4페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight*2);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 2 + DIVIDER_HEIGHT ,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(3);
//         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 5) {
//           // 현재 5페이지
//           console.log("현재 5페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight*3);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 3 + DIVIDER_HEIGHT ,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(4);
//         } else {
//           // 현재 6페이지
//           console.log("현재 6페이지, up scrollTop:",scrollTop, "pageHeight:",pageHeight*4);
//           outerDivRef.current.scrollTo({
//             top: pageHeight * 4 + DIVIDER_HEIGHT * 4,
//             left: 0,
//             behavior: "smooth",
//           });
//           setCurrentPage(5);
//         }
//       }
//     };

//     const touchStartHandler = (e) => {
//       startY = e.touches[0].clientY;
//       console.log("터치 한 부분:",startY)
//     };
//     const touchEnd = (e) => {
//       // e.preventDefault();
//       endY = e.changedTouches[0].clientY;
//       // console.log("터치 끝 부분:",endY )
//     };

//     const outerDivRefCurrent = outerDivRef.current;
//     outerDivRefCurrent.addEventListener("wheel", wheelHandler);
//     outerDivRefCurrent.addEventListener("touchstart", touchStartHandler);
//     outerDivRefCurrent.addEventListener("touchmove", wheelHandler); //touchend touchmove
//     // outerDivRefCurrent.addEventListener("touchend", touchEnd);
//     return () => {
//       outerDivRefCurrent.removeEventListener("wheel", wheelHandler);
//       outerDivRefCurrent.removeEventListener("touchstart", touchStartHandler);
//       outerDivRefCurrent.removeEventListener("touchmove", wheelHandler);
//       // outerDivRefCurrent.removeEventListener("touchend", touchEnd);
//     };
//   }, []);

//   /** 방법2 */
//   // const pageRef = useRef()
//   // useEffect(() => {
//   //   // 회면 세로 길이
//   //   const pageHeight = window.innerHeight;
//   //   let startY;
//   //   // 모바일에서 터치 스크롤 시
//   //   // 터치가 발생된 지점의 Y 좌표를 저장
//   //   const scrollHandler = (e) => {
//   //     e.preventDefault();
//   //     const deltaY = 'deltaY' in e ? e.deltaY : startY - e.touches[0].clientY;
//   //     const { current: pageRefCurrent } = pageRef;
//   //     // const { pageRefCurrent } = pageRef.current;
//   //     console.log("deltaY",deltaY)
//   //     if (pageRefCurrent) {
//   //       const { scrollTop } = pageRefCurrent;
//   //       if (deltaY > 0) {
//   //         // 아래로 스크롤
//   //         if (scrollTop >= 0 && scrollTop < pageHeight) {
//   //           console.log("현재 2페이지, down scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 2) {
//   //           console.log("현재 3페이지, down scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 2,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 2 &&
//   //           scrollTop < pageHeight * 3
//   //         ) {
//   //           console.log("현재 4페이지, down scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 3,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 3 &&
//   //           scrollTop < pageHeight * 4
//   //         ) {
//   //           console.log("현재 5페이지, down scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 4,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 4 &&
//   //           scrollTop < pageHeight * 5
//   //         ) {
//   //           console.log("현재 6페이지, down scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 5,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         }
//   //       } else if (deltaY < 0) {
//   //         // 위로 스크롤
//   //         if (scrollTop >= 0 && scrollTop < pageHeight) {
//   //           console.log("현재 1페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: 0,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (scrollTop >= pageHeight && scrollTop < pageHeight * 2) {
//   //           console.log("현재 2페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: 0,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 2 &&
//   //           scrollTop < pageHeight * 3
//   //         ) {
//   //           console.log("현재 3페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 3 &&
//   //           scrollTop < pageHeight * 4
//   //         ) {
//   //           console.log("현재 4페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 2,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 4 &&
//   //           scrollTop < pageHeight * 5
//   //         ) {
//   //           console.log("현재 5페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 3,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } else if (
//   //           scrollTop >= pageHeight * 5 &&
//   //           scrollTop < pageHeight * 6
//   //         ) {
//   //           console.log("현재 6페이지, up scrollTop:",scrollTop)
//   //           pageRef.current?.scrollTo({
//   //             top: pageHeight * 4,
//   //             left: 0,
//   //             behavior: 'smooth',
//   //           });
//   //         } 
//   //       }
//   //     }
//   //   };
//   //   const touchStartHandler = (e) => {
//   //     startY = e.touches[0].clientY;
//   //     console.log(startY)
//   //   };


//   //   pageRef.current?.addEventListener('wheel', scrollHandler);
//   //   pageRef.current?.addEventListener('touchstart', touchStartHandler);
//   //   pageRef.current?.addEventListener('touchmove', scrollHandler);

//   //   return () => {
//   //     pageRef.current?.removeEventListener('wheel', scrollHandler);
//   //     pageRef.current?.removeEventListener('touchstart', touchStartHandler);
//   //     pageRef.current?.removeEventListener('touchmove', scrollHandler);
//   //   };
//   // }, []);

//   const onClickDotEvent = (e) => {
//     const viewHeight = window.innerHeight;
//     console.log("눌림", viewHeight, e, viewHeight * (e-1) + DIVIDER_HEIGHT * (e-1));
//     outerDivRef.current.scrollTo({
//       top: viewHeight * (e-1) + DIVIDER_HEIGHT * (e-1),
//       left: 0,
//       behavior: "smooth",
//     });
//     setCurrentPage(e);
//   }
//   return (
//     <>
//       {/* <MainImage/> */}
//       <div className='outer_div' 
//       ref={outerDivRef} 
//       // ref={pageRef}
//       >
//       <Dots currentPage={currentPage} onClickDotEvent={onClickDotEvent}/>
//         <div className='inner_div'>
//         <span>First</span>
//         </div>
//         <div className="divider"/>
//         <div className='inner_div'>
//         <span>Second</span>
//         </div>
//         <div className="divider"/>
//         <div className='inner_div'>
//         <span>Third</span>
//         </div>
//         <div className="divider"/>
//         <div className='inner_div'>
//         <span>Fourth</span>
//         </div>
//         <div className="divider"/>
//         <div className='inner_div'>
//         <span>Fiveth</span>
//         </div>
//         <div className="divider"/>
//         <div className='inner_div last'>
//         <span>Sixth</span>

//         </div>

//         <div>
//         {/* <div className="inner_div last"> */}
//         <Footer />
//         </div>

//       </div>

//     </>
//   )
// }

// export default Main2
import { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';

function Main2() {
  const DIVIDER_HEIGHT = 0;
  const outerDivRef = useRef();
  const FOOTER_HEIGHT = 348;
  const [currentPage, setCurrentPage] = useState(1);
  let startY; // 터치 시작 위치
  const [isScrolling, setIsScrolling] = useState(false); // 스크롤 여부 상태

  // 페이지 높이를 미리 계산
  const pageHeight = window.innerHeight;
  
  const scrollToPage = (page) => {
    outerDivRef.current.scrollTo({
      top: page * (pageHeight + DIVIDER_HEIGHT),
      left: 0,
      behavior: "smooth",
    });
    setCurrentPage(page + 1); // 페이지는 0부터 시작하므로 +1
  };

  const handleWheel = (e) => {
    e.preventDefault();
    if (isScrolling) return; // 이미 스크롤 중이면 리턴
    setIsScrolling(true); // 스크롤 시작

    const deltaY = e.deltaY;

    if (deltaY > 0) {
      if (currentPage < 6) { // 6페이지까지 존재한다고 가정
        scrollToPage(currentPage);
      }
    } else {
      if (currentPage > 1) {
        scrollToPage(currentPage - 2); // 이전 페이지로
      }
    }
    // 1초 후에 스크롤 상태 리셋
    setTimeout(() => {
      setIsScrolling(false);
    }, 1000); // 1000ms = 1초
  };

  const handleTouchStart = (e) => {
    startY = e.touches[0].clientY; // 터치 시작 위치 저장
  };

  const handleTouchMove = (e) => {
    e.preventDefault(); // preventDefault를 호출하여 스크롤 방지
    const deltaY = startY - e.touches[0].clientY; // 터치 이동 거리
    // deltaY가 0보다 크면 아래로 스크롤, 작으면 위로 스크롤
    if (isScrolling) return; // 이미 스크롤 중이면 리턴
    setIsScrolling(true); // 스크롤 시작

    // 터치 방향에 따라 페이지 이동
    // if (deltaY > 10) {
    //   if (currentPage < 6) { // 6페이지까지 존재한다고 가정
    //     console.log("큼!",currentPage)
    //     scrollToPage(currentPage);
    //   }
    // } else if(deltaY < -10 ) {
    //   if (currentPage > 1) {
    //     scrollToPage(currentPage - 2); // 이전 페이지로
    //   }
    // }

    // 터치 방향에 따라 페이지 이동
    if (deltaY > 0 && currentPage < 6) {
      scrollToPage(currentPage);
    } else if (deltaY < 0 && currentPage > 1) {
      scrollToPage(currentPage - 2); // 이전 페이지로
    }

    // 1초 후에 스크롤 상태 리셋
    setTimeout(() => {
      setIsScrolling(false);
    }, 700); // 1000ms = 1초
    //마지막 리셋해주기
    startY = 0
  };


  useEffect(() => {
    const outerDiv = outerDivRef.current;
    outerDiv.addEventListener("wheel", handleWheel);
    outerDiv.addEventListener("touchstart", handleTouchStart);
    outerDiv.addEventListener("touchmove", handleTouchMove);

    return () => {
      outerDiv.removeEventListener("wheel", handleWheel);
      outerDiv.removeEventListener("touchstart", handleTouchStart);
      outerDiv.removeEventListener("touchmove", handleTouchMove);
    };
  }, [currentPage, isScrolling, pageHeight, outerDivRef]); // isScrolling 추가

  const onClickDotEvent = (e) => {
    scrollToPage(e - 1); // 페이지 인덱스가 0부터 시작하므로 -1
  };

  return (
    <>
     <ImagePopup popupId="popup1" >
            <h3>제5회 공공부문 SW AWARD</h3>
          <span>
            {`
       수상부문 : 클라우드 SaaS

회사명 : ㈜이케이시스

대표자 : 김경열

제품명 : 교통약자 이동지원 클라우드 SaaS 관제서비스

2025.05.16
        `}
          </span>
      </ImagePopup>
    {/* <OneDayPopup popupId="popup1" >
         <div style={{ width: "100%", height: "100%", textAlign: "center" }} >
        
          <img src="images/shared image (2).jpeg"/>
            <h3>제5회 공공부문 SW AWARD</h3>
          <span>
            {`
       수상부문 : 클라우드 SaaS

회사명 : ㈜이케이시스

대표자 : 김경열

제품명 : 교통약자 이동지원 클라우드 SaaS 관제서비스

2025.05.16
        `}
          </span>
        </div>
      </OneDayPopup> */}
      
     
      {/* <OneDayPopup popupId="popup1" >
        <div style={{ width: "100%", height: "100%" }} >
          <h3>개인위치정보사업자 폐업 안내</h3>
          <span>
            {`
        안녕하세요, 고객님.

저희 개인위치정보사업자가 폐업하게 되어 안내드립니다. 이에 따라 서비스 제공이 중단되며, 더 이상 위치 정보 서비스를 이용하실 수 없습니다.

서비스 중단 일자: [폐업 일자]

그동안 저희 서비스를 이용해 주셔서 감사드리며, 불편을 드려 죄송합니다. 추가 문의 사항이 있으시면 고객센터로 연락해 주시기 바랍니다.

감사합니다.
        `}
          </span>
        </div>
      </OneDayPopup>

      <OneDayPopup  popupId="popup2">
          <h3>개인위치정보사업자 휴업 안내</h3> 
          <span>
            {` 
          안녕하세요, 고객님.

          저희 개인위치정보사업자가 휴업하게 되어 안내드립니다. 이에 따라 서비스 제공이 일시적으로 중단되며, 휴업 기간 동안 위치 정보 서비스를 이용하실 수 없습니다.

          휴업 기간: [휴업 시작 일자] ~ [휴업 종료 일자]

          그동안 저희 서비스를 이용해 주셔서 감사드리며, 불편을 드려 죄송합니다. 추가 문의 사항이 있으시면 고객센터로 연락해 주시기 바랍니다.

          감사합니다.
          `}
          </span>
      </OneDayPopup> */}

      <div className='outer_div' ref={outerDivRef}>
        <Dots currentPage={currentPage} onClickDotEvent={onClickDotEvent} />
        <div className='inner_div main'>
            <MainImage className={`blur_${currentPage == 1 ? "off" : "on" }`} />
        </div>
        {/* <div className="divider" /> */}
        <div className='inner_div'>
          {/* <div className='front_second' ref={(el) => (refs.current[1] = el)}> */}
          <div className='front_second_main_img'>
            <div className='second_sub'>
              eKsys is Leading Company of New GIS Software Products
            </div>
            <div className='second_title'>
              창조적인 사고, 혁신적인 개발, 합리적인 기술을 제공 경영이념을 바탕으로
              IT Business 기업으로서,<br />
              방향성과 방법론에 대한 연구를 통해 그 기술력을 인정받고 있습니다.
            </div>
            {/* </div> */}
          </div>
        </div>
        {/* <div className="divider" /> */}
        <div className='inner_div main'>
          <div className='front_wrap_new'>
            <div className='wrap_img_con'>
              <img src='images/eksys_Iphone.png' className='front_main_img fit' alt='이케이시스 설명 이미지' />
            </div>
            
            <div className='front_main_sub intro'>
              {/* <span className='sub_margin'> */}
              <span className=''>
                <span className='sky_blue_span'>GIS Engine 개발</span>
                <span className='deep_blue_span'>Mobile 네비게이션</span>
                <span className='green_span'>LBS 관련 서비스</span>
                분야에 끊임 없는 기술개발로 성장해 가고 있습니다.
              </span>
            </div>
          </div>

        </div>
        {/* <div className="divider" /> */}
        <div className='inner_div dynamic'>
          <ProductMenuNew />
          {/* <ProductMenu /> */}
          {/* <Slideritem/> */}
        </div>
        {/* <div className="divider" /> */}
        <div className='inner_div partner'>
          <PartnerNew />
        </div>
        {/* <div className="divider" /> */}

        {/* <div className='inner_div last'>
          <div className='contact_div_new' >
            <div className='second_sub mo' >
              제품에 대한 문의를 주세요.
              <br />
              보다 빠른 답변을 위해 노력하겠습니다.
            </div>
            <Link to={URL.CONTACT} className='contact_btn'>CONTACT US</Link>
          </div>
        </div>
        <Footer /> */}
         <div className='inner_div last'>
          <div className='contact_div_new' >
            <div className='second_sub mo' >
              제품에 대한 문의를 주세요.
              <br />
              보다 빠른 답변을 위해 노력하겠습니다.
            </div>
            <Link to={URL.CONTACT} className='contact_btn'>CONTACT US</Link>
          </div>
          
          
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Main2;